<template>
  <navbarResp></navbarResp>
  <main v-if="manageables" >
    <videoResp></videoResp>
    <about-usRes  :whoweare="manageables.whoweare" :mission="manageables.mission" :vision="manageables.vision" ></about-usRes>
    <tabs></tabs>
    <bypasses></bypasses>
    <board :bypassslp="manageables.bypassslp" :node="manageables.node"></board>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-12 carouselClass2">
          <carousel-images />
        </div>
      </div>
    </div>
    <sust :sustainability="manageables.sustainability"></sust>
    <nutri :nurturing="manageables.nurturing" :nurturinglink="manageables.nurturinglink"></nutri>
    <business :businessres="manageables.businessres"></business>
    <security :infrastructure="manageables.infrastructure" :helpvial="manageables.helpvial" :androlink="manageables.androlink" :ioslink="manageables.ioslink"></security>
    <paraderoinf :hostel="manageables.hostel"></paraderoinf>
    <latte-express-inf></latte-express-inf>
    <paradero></paradero>
    <contact-us></contact-us>
    <!-- <div class="row">
      <div class="col-lg-7 mb-lg">
        line chart
        <div class="card z-index-2">
          <gradient-line-chart />
        </div>
      </div>
      <div class="col-lg-5">
        <carousel />
      </div>
    </div> -->
  </main>
  <Footer></Footer>
  <FloatingActionBut></FloatingActionBut>
</template>

<script>
import FloatingActionBut from "./components/FloatingActionBut.vue";
//import Navbar2 from "./components/Navbar2.vue";
import Bypasses from "./Bypasses.vue";
import NavbarResp from './components/NavbarResp.vue';
// import NavbarAlt from './components/NavbarAlt.vue';
// import MainVideo from "./components/Video.vue";
import videoResp from "./components/VideoResp.vue";
import AboutUsRes from './AboutUsRes.vue';
import Board from "./Board.vue";
import Tabs from './Tabs.vue'
//import Rates from './rates.vue';
import Sust from './Sustentabilidad.vue'
import Nutri from './Nutriendo.vue'
import Business from './Businessres.vue'
import Paraderoinf from './Paradorinf.vue'
import Paradero from './Paradero.vue'
import Security from './Security.vue'
import ContactUs from './ContactUs.vue';
// import AboutUs from './AboutUs.vue';
import Footer from './Footer.vue';
// import Carousel from "../components/Carousel.vue";
import CarouselImages from "../components/CarouselImages.vue";
import LatteExpressInf from './LatteExpressInf.vue';
// import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
// import Carousel from "../components/Carousel.vue";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  data() {
        return {
            manageables: undefined,
        };
  },
  components: {
    FloatingActionBut,
    // Navbar,
    //Navbar2,
    // MainVideo,
    videoResp,
    // Rates,
    AboutUsRes,
    Tabs,
    Board,
    Sust,
    Business,
    Nutri,
    Security,
    Paraderoinf,
    Paradero,
    ContactUs,
    // AboutUs,
    Footer,
    // NavbarAlt,
    NavbarResp,
    Bypasses,
    //ArgonInput,
    //ArgonCheckbox,
    //ArgonButton,
    // Carousel,
    // GradientLineChart,
    CarouselImages,
    LatteExpressInf,
},
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
    this.plain
    .get(`/manageables`)
    .then((response) => {
      if (response.data.length !== 0) this.manageables = response.data[0];
      else this.manageables = undefined;
        // console.log(this.manageables)
    })
    .catch((err) => {
      this.manageables = undefined;
      console.log(err);
    });
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>


<style scoped>
.carouselClass2 {
  height: 40vw;
}
</style>